import { NoteDropActions, useNoteDropZone } from '@spa/scenes/Plannings/DnD'
import type { PropsWithChildren, FC, ReactElement } from 'react'
import React from 'react'

import { usePlanningPolicies } from '../../../../redux/selectors'

import styles from './NoteDropZone.module.css'

type Props = {
  weeklyscheduleId: number
  date: string
}

export const NoteDropZone: FC<PropsWithChildren<Props>> = React.memo(
  ({ children = null, weeklyscheduleId, date }) => {
    const [data, drop] = useNoteDropZone()
    const divRef = React.useRef<HTMLDivElement>(null)
    const combinedRef = React.useCallback(
      (node: HTMLDivElement) => {
        divRef.current = node
        drop(node)
      },
      [drop]
    )

    const { canDNDNote } = usePlanningPolicies()

    if (!canDNDNote) {
      return children as ReactElement
    }

    return (
      <div ref={combinedRef} className={styles.Container}>
        {children}
        {data.isDragging && data.isOver && (
          <div className={styles.Over}>
            <NoteDropActions
              item={data.item}
              weeklyscheduleId={weeklyscheduleId}
              date={date}
            />
          </div>
        )}
      </div>
    )
  }
)

NoteDropZone.displayName = 'NoteDropZone'
